import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nested-mat-tree',
  templateUrl: './nested-mat-tree.component.html',
  styleUrls: ['./nested-mat-tree.component.scss']
})
export class NestedMatTreeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
